import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

type ConfusionMatrixParams = {
  programId?: string
  startDate?: string
  endDate?: string
  systemId?: string
  softwareVersion?: string
  enabled?: boolean
}

export type ConfusionMatrixCell = {
  predicted: string
  resolved: string
  count: number
  share: number
}

export type ConfusionMatrixResponse = {
  labels: string[]
  cells: ConfusionMatrixCell[]
  totalEngagements: number
  totalErrors: number
  totalCorrect: number
}

export const CONFUSION_MATRIX_KEY = 'program-confusion-matrix'

export function useGetConfusionMatrix(params: ConfusionMatrixParams) {
  const { programId, startDate, endDate, enabled = true, ...queryParams } = params

  const cleanedParams = Object.fromEntries(
    Object.entries({ startDate, endDate, ...queryParams }).filter(
      ([, v]) => v !== undefined && v !== null && v !== ''
    )
  )

  const TEN_MINUTES = 1000 * 60 * 10

  return useQuery<ConfusionMatrixResponse>({
    queryKey: [CONFUSION_MATRIX_KEY, { programId, startDate, endDate, ...queryParams }],
    queryFn: async () => {
      const response = await apiClient.get(`/int/v3/programs/${programId}/metrics/confusion-matrix`, {
        params: cleanedParams,
      })
      return response.data
    },
    enabled: enabled && Boolean(programId) && Boolean(startDate) && Boolean(endDate),
    refetchOnWindowFocus: false,
    staleTime: TEN_MINUTES,
  })
}
